import React from 'react'
import './M_ElementDrawer.css'
import { SwipeableDrawer, Tooltip, useMediaQuery } from '@mui/material'
import { DragHandle } from '@mui/icons-material'
import { useResize, M_Button } from '../../M_Components'

export const M_ElementDrawer = ({ open, setOpen, onClose, element, toolTipClose }) => {
    const { width, enableResize } = useResize(400)
    const match = useMediaQuery('(max-width: 900px)')

    const closeDrawer = () => {
        onClose()
        setOpen(false)
    }

    const toggleDrawer = () => {
        setOpen(true)
    }

    return (
        <>
            <SwipeableDrawer
                className="M_swipeableDrawer"
                anchor={'right'}
                open={open}
                onClose={() => closeDrawer()}
                onOpen={() => toggleDrawer()}
                PaperProps={{ style: { minWidth: (match ? 'auto' : '900px'), width, maxWidth: '1400px' } }}
            >
                <Tooltip title={toolTipClose ? toolTipClose : ""}>
                    <div style={{ display: 'flex', justifyContent: 'left', marginLeft: '5px', width: 'max-content' }}>
                        <M_Button
                            none
                            icon={<i className="pi pi-times " />}
                            onClick={() => closeDrawer()}
                        />
                    </div>
                </Tooltip>
                <div id='dragger' className='M_divDragger'>
                    <div className='M_divInteriorDragger'>
                        <DragHandle className='M_dragHandleIcon' onMouseDown={(e) => {
                            enableResize(e)
                        }} />
                    </div>
                </div>
                <div style={{ zIndex: '1202', marginLeft: '10px', height: '100%', overflow: 'auto' }}>
                    {element}
                </div>
            </SwipeableDrawer>
        </>
    )
}
